module.exports = __webpack_public_path__ + "img/root00.f1f1538f.png";